export const apiConstants = {
  LOGIN_API_ENDPOINT: "login-user",
  CAR_MAKE_ENDPOINT: "car",
  CAR_MODELS_ENDPOINT: "models",
  GET_APPRAISAL_BY_ID: "appraisals", // id will be added in dynamic params
  GET_APPRAISALS: "appraisals",
  POST_OR_PUT_APPRAISALS: "appraisals",
  PUT_SHOP_STATUS: "appraisals/update-status",
  GET_CHAT_BY_APPRAISAL_ID: "/chat/get-chat-by-appraisal-id",
  POST_CHAT_MESSAGES: "/chat/create-chat",
  UPDATE_NOTIFY: "/appraisal-notify-update",
  UPDATE_CHAT: "/chat/update-chat-by-id",
  FETCH_ALL_CAPABILITIES: "/shop/get-all-capabilities",
  CREATE_SHOP: "/shop/create-shop",
  EDIT_SHOP: "/shop/update-shop-by-id",
  // GET_ALL_ROLE_USERS: "/shop/get-all-role-users"
  GET_ALL_ROLE_USERS: "/user/get-users-for-shop",
  GET_SHOP_INFO_BY_OWNER: "/shop/get-shop-by-shop-owner",
  REGISTER_USER: "/user-register",
  GET_ALL_SHOPS: "/shop/get-all-shops",
  GET_ALL_STAFF: "/user/get-all-users",
  GET_SHOP_BY_ID: "/shop/get-shop-by-id",
  GET_STAFF_BY_ID: "/user/get-user",
  DELETE_SHOP: "/shop/delete-shop-by-id",
  FETCH_ALL_ROLES: "/role/get-all-roles",
  GET_ROLE_BY_ID: "/role/get-role-by-id",
  UPDATE_ROLE_PERMISSIONS: "/role/update-role-by-id",
  EDIT_USER: "/user/update-user-by-id",
  GET_APPRAISAL_WORKFLOW: "/appraisals/work-flow-report",
  GET_WRITER_QUALITY: "/appraisals/writer-estimate-report",
  GET_ALL_CARS: "/cars",
  GET_WRITER_WORKLOAD: "/appraisals/writer-workload-report",
  NOTIFICATIONS: "/notifications",
  UPDATE_WRITER_ON_APPRAISAL: "/appraisals/update-writer-by-appr-id",
  BULK_UPDATE_APPRAISALS_ON_WRITER: "/appraisals/update-writer-by-apprs",
  LOGOUT_USER: "/logout-user",
  CREATE_INSURANCE_COMPANY: "/insurance/create-insurance",
  GET_ALL_INSURANCE_COMPANY: "/insurance/get-all-insurance",
  GET_INSURANCE_COMPANY_BY_ID: "/insurance/get-insurance-by-id",
  DELETE_INSURANCE_COMPANY_BY_ID: "/insurance/delete-insurance-by-id",
  UPDATE_INSURANCE_COMPANY_BY_ID: "/insurance/update-insurance-by-id",
  UPDATE_SLA_CONFIG: "/sla/update-sla-by-id",
  GET_SLA_CONFIG: "/sla/get-sla-by-id",
  GET_OVERDUE_DATA: "/appraisals/get-appraisal-insights",
  RATING_LIST_DATA: "/appraisals/get-ratings-insights",
  RATING_LIST_WRITERS: "/appraisals/get-writers-by-rating",
  VERIFY_TOKEN: "/user/verify-token",
  RESEND_ONBOADRING_EMAIL: "user/resend-onboarding-email",
  UPLOAD_DELETE_IMAGE: "/files/handle"
};
